import React from 'react';
import { NavLink } from 'react-router-dom';
import { RepaartLogo } from '../../components/common/RepaartLogo';
import UserMenu from './UserMenu';
import Notifications from './Notifications';
import { adminNavItems, franchiseNavItems, riderNavItems } from '../constants/navigation';

export interface HeaderProps {
    isAdmin: boolean;
    isFranchise?: boolean;
    isRider?: boolean;
    targetFranchiseName?: string;
    onExport?: () => void;
    onOpenHelp?: (id: string) => void;
}

const Header: React.FC<HeaderProps> = ({ isAdmin, isFranchise, isRider }) => {
    const navItems = isAdmin ? adminNavItems : isFranchise ? franchiseNavItems : isRider ? riderNavItems : [];

    return (
        <header className="app-header pointer-events-none sticky top-0 z-40 w-full px-3 py-3 sm:px-5 lg:px-8">
            <div className="mx-auto flex max-w-[1920px] items-center justify-between gap-3">
                <div className="pointer-events-auto">
                    <NavLink to="/" className="app-chrome flex h-12 items-center px-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ruby-500" aria-label="Ir al inicio">
                        <RepaartLogo iconOnly={false} />
                    </NavLink>
                </div>

                <div className="hidden xl:flex pointer-events-auto">
                    <nav className="app-chrome flex items-center gap-1 p-1" aria-label="Navegacion principal">
                        {navItems.map((item) => (
                            <NavLink
                                key={item.path}
                                to={item.path}
                                className={({ isActive }) => `flex h-10 items-center gap-2 rounded-lg px-3 text-sm font-semibold transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ruby-500 ${isActive
                                    ? 'bg-ruby-600 text-white'
                                    : 'text-slate-600 hover:bg-black/[0.04] hover:text-slate-950 dark:text-slate-300 dark:hover:bg-white/[0.07] dark:hover:text-white'
                                    }`}
                            >
                                <item.icon className="h-[18px] w-[18px] shrink-0" aria-hidden="true" />
                                <span className="whitespace-nowrap">{item.label}</span>
                            </NavLink>
                        ))}
                    </nav>
                </div>

                <div className="pointer-events-auto flex items-center gap-2">
                    <div className="app-chrome app-icon-control">
                        <Notifications isAdmin={isAdmin} />
                    </div>

                    <div className="app-chrome flex min-h-12 items-center px-2">
                        <UserMenu
                            isFranchise={isFranchise}
                            isRider={isRider}
                        />
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
